import React from 'react';
import { LicenseState } from '../model/LicenseState';

const LicenseStateBadge = ({ state }: Props) => {
  return (
    <span className={`badge text-capitalize ${state === LicenseState.licensed ? 'bg-label-success' : 'bg-label-danger'}`}>{state}</span>
  );
}

interface Props {
  state: LicenseState
}

export { LicenseStateBadge };